import { render } from "./Geographic.vue?vue&type=template&id=da815f20&scoped=true"
import script from "./Geographic.vue?vue&type=script&lang=js"
export * from "./Geographic.vue?vue&type=script&lang=js"

import "./Geographic.vue?vue&type=style&index=0&id=da815f20&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da815f20"]])

export default __exports__